import React, { useEffect, useState } from 'react';
import { BrandDescriptor, ExternalName } from '../../common/general/module/brand-loader';
import { ModuleContext, ModuleContextContent } from './module-context';
import { Brand } from '../dwt-app';

const brandLoaders: Record<
  Brand,
  (param?: any, param1?: any) => Promise<{ default: BrandDescriptor } | BrandDescriptor>
> = {
  peugeot: () => import('../../common/general/module/peugeot-loader'),
  opel: () => import('../../common/general/module/opelnew-loader'),
  ds: () => import('../../common/general/module/ds-loader'),
  citroen: () => import('../../common/general/module/citroen-loader'),
  opelnew: () => import('../../common/general/module/opelnew-loader'),
  admin: () => import('../../common/general/module/admin-loader'),
  ssangyong: async (isKgm?: any, kgmStyle?: any): Promise<BrandDescriptor> => {
    const module = await import('../../common/general/module/ssangyong-loader');
    const loadSsangyong = module.default as (p: any, g: any) => BrandDescriptor;
    return loadSsangyong(isKgm, kgmStyle);
  },
  isuzu: () => import('../../common/general/module/isuzu-loader'),
  fiat: async (isFiatPro?: any): Promise<BrandDescriptor> => {
    const module = await import('../../common/general/module/fiat-loader');
    const loadFiat = module.default as (p: any) => BrandDescriptor;
    return loadFiat(isFiatPro);
  },
  jeep: () => import('../../common/general/module/jeep-loader'),
  alfaromeo: () => import('../../common/general/module/alfa-loader'),
  abarth: () => import('../../common/general/module/abarth-loader'),
  lancia: () => import('../../common/general/module/lancia-loader'),
};

interface Props {
  brand: Brand | undefined;
  moduleName: ExternalName;
  adminMode?: boolean;
  customData?: any;
  widgetData?: any;
}

const loadModuleContext = async (props: Props): Promise<ModuleContextContent> => {
  const brandDescriptor: any | BrandDescriptor = await brandLoaders[
    (props.adminMode ? 'admin' : props.brand) || 'opelnew'
  ](props.customData);
  const [modules, theme] = brandDescriptor.default || brandDescriptor;
  const module = modules.find((m: any) => m.externalName === props.moduleName);
  if (!module) {
    throw new Error('Unrecognized module name: ' + props.moduleName);
  }
  return { module, basetheme: theme };
};

export const ModuleContextProvider = (props: React.PropsWithChildren<Props>) => {
  const [context, setContext] = useState<ModuleContextContent | undefined>(undefined);

  useEffect(() => {
    loadModuleContext(props).then((moduleContext) => setContext(moduleContext));
  }, []);

  return <ModuleContext.Provider value={context}>{props.children}</ModuleContext.Provider>;
};
